import { render, staticRenderFns } from "./AgentChatWindow.vue?vue&type=template&id=cd0abc3a&scoped=true&"
import script from "./AgentChatWindow.vue?vue&type=script&lang=js&"
export * from "./AgentChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./AgentChatWindow.vue?vue&type=style&index=0&id=cd0abc3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0abc3a",
  null
  
)

export default component.exports